import { BreadcrumbGroup } from '@cloudscape-design/components';
import { useGetOrgById } from 'hooks/use-basicQueries';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export default function OrganizationBreadcrumbs({ pathnames }) {
  const navigate = useNavigate();
  const orgId = pathnames[1];
  const { data: organization } = useGetOrgById(orgId);

  const breadcrumbItems = useMemo(() => {
    const items = [
      { text: 'Home', href: '/' },
      { text: 'Organizations', href: '/organizations' },
    ];

    if (organization?.name) {
      items.push({ text: organization.name });
    }

    return items;
  }, [organization?.name]);

  return (
    <BreadcrumbGroup
      onClick={(e) => {
        e.preventDefault();
        const { href } = e.detail;
        if (href) {
          navigate(href);
        }
      }}
      items={breadcrumbItems}
    />
  );
}
OrganizationBreadcrumbs.propTypes = {
  pathnames: PropTypes.arrayOf(PropTypes.string).isRequired,
};
